<h2 mat-dialog-title>Import dataset file</h2>
<mat-dialog-content>
  <div class="content">
    <p>Press <code>CMD + SHIFT + .</code> to show hidden files in file picker</p>
    <div class="entry">
      <mat-form-field appearance="fill">
        <mat-label>.dataset file</mat-label>
        <ngx-mat-file-input required [formControl]="datasetFileControl"
          placeholder=".dataset file"></ngx-mat-file-input>
        <mat-icon matSuffix svgIcon="layers"></mat-icon>
      </mat-form-field>

      <div class="preview-button-wrapper">
        <button mat-raised-button type="button" (click)="processInputFile()">
          <mat-icon svgIcon="eye"></mat-icon>
          <span>Preview</span>
        </button>
      </div>
    </div>

    <pre *ngIf="jsonContent"><code>{{ jsonContent | json }}</code></pre>
  </div>
</mat-dialog-content>

<div mat-dialog-actions class="actions">
  <button mat-raised-button [disabled]="importButtonDisabled" (click)="importDatasetFile()">Import</button>
  <span class="spacer"></span>
  <button mat-raised-button (click)="closeDialog()">Cancel</button>
</div>
